import { render, staticRenderFns } from "./AddRequestBreackDown.vue?vue&type=template&id=6605b1a2&scoped=true&"
import script from "./AddRequestBreackDown.vue?vue&type=script&lang=js&"
export * from "./AddRequestBreackDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6605b1a2",
  null
  
)

export default component.exports